export enum PLACEMENT {
  T = 't',
  TL = 'tl',
  TR = 'tr',
  B = 'b',
  BL = 'bl',
  BR = 'br',
  L = 'l',
  LT = 'lt',
  LB = 'lb',
  R = 'r',
  RT = 'rt',
  RB = 'rb'
}
